import React from "react";
// COMPONENTS
import SiteButton from "Components/WebsiteTheme/SiteButton";
import { IconFlag, ToneIcon } from "Components/WebsiteTheme/SiteIcons";
import { revealProps } from "Components/WebsiteTheme/Reveal";
import { CTA, PILLARS } from "Components/WebsiteTheme/site.data";
// STYLES
import { PilotBandSection } from "./LandingPage.style";
// IMAGES
import PilotPhoto from "Assets/Images/ClassroomPilot/happy-older-students-classroom.jpg";

/** Classroom Pilot invitation on a navy band, with the three pillars. */
const PilotBand = () => (
	<PilotBandSection className="sm_on_dark" aria-labelledby="home-pilot-title">
		<div className="sm_container pb_inner">
			<div className="pb_photo">
				<img src={PilotPhoto} alt="Happy high school students collaborating with a laptop and notebooks in a classroom" width="1400" height="933" loading="lazy" />
			</div>

			<div className="pb_copy" {...revealProps("up")}>
				<span className="pb_pill">
					<IconFlag />
					Classroom Pilot
				</span>
				<h2 id="home-pilot-title" className="sm_title">
					Bring Subjects Master Into Your Classroom.
				</h2>
				<p className="sm_body">
					Experience Subjects Master with your students. Use the platform to reinforce what you’re already teaching, turn review into interactive gaming challenges, and gain insight into
					student performance.
				</p>
				<SiteButton to={CTA.pilot.to}>{CTA.pilot.label}</SiteButton>
			</div>

			<span className="pb_divider" aria-hidden="true" />

			<ul className="pb_pillars">
				{PILLARS.map((pillar, index) => (
					<li key={pillar.key} {...revealProps("right", index + 1)}>
						<ToneIcon iconKey={pillar.key} tone={pillar.tone} />
						<div className="pb_pillar_copy">
							<h3 className="sm_h4">{pillar.title}</h3>
							<p className="sm_small">{pillar.short}</p>
						</div>
					</li>
				))}
			</ul>
		</div>
	</PilotBandSection>
);

export default PilotBand;
